"use client";

import React from "react";
import AppImage from "@/components/ui/AppImage";
import ScrollReveal from "./ScrollReveal";

interface ProfileSectionProps {
  name?: string;
  title?: string;
  company: string;
  tagline: string;
  photoUrl: string;
  photoAlt: string;
}

export default function ProfileSection({
  company,
  tagline,
  photoUrl,
  photoAlt,
}: ProfileSectionProps) {
  return (
    <div className="px-6 pb-6">
      {/* Profile photo */}
      <ScrollReveal delay={0} className="flex items-end gap-4 -mt-12 mb-6">
        <div className="profile-ring animate-float flex-shrink-0" style={{ width: 96, height: 96 }}>
          <div
            className="rounded-full overflow-hidden bg-gray-200"
            style={{ width: 90, height: 90 }}
          >
            <AppImage
              src={photoUrl}
              alt={photoAlt}
              width={90}
              height={90}
              className="w-full h-full object-cover"
              priority
            />
          </div>
        </div>
      </ScrollReveal>

      {/* Divider */}
      <div className="section-divider my-5" />

      {/* Company info */}
      <ScrollReveal delay={200}>
        <h2
          className="font-jakarta font-bold text-primary"
          style={{ fontSize: "17px" }}
        >
          {company}
        </h2>
        <p
          className="font-sans text-muted mt-0.5"
          style={{ fontSize: "14px" }}
        >
          {tagline}
        </p>
      </ScrollReveal>
    </div>
  );
}